import React, { useState } from "react";
import {  getAuth, signInWithEmailAndPassword, setPersistence, browserLocalPersistence  } from "firebase/auth";
import { useNavigate, useLocation } from "react-router-dom";

export default function Login() {
  const [email, setEmail] = useState("");
  const [motDePasse, setMotDePasse] = useState("");
  const [erreur, setErreur] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
const from = location.state?.from?.pathname || "/admin/items";

  const handleLogin = async (e) => {
  e.preventDefault();
  setErreur("");
  setLoading(true);

  const auth = getAuth();

  try {
    await setPersistence(auth, browserLocalPersistence);
    await signInWithEmailAndPassword(auth, email, motDePasse);
    navigate(from, { replace: true }); // ← redirige vers la page demandée
  } catch (error) {
    console.error("Erreur de connexion :", error.message);
    setErreur("Email ou mot de passe invalide.");
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="container d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
      <div className="card p-4 shadow w-100" style={{ maxWidth: 400 }}>
        <h3 className="text-center mb-3">Connexion Admin</h3>

        {erreur && <div className="alert alert-danger">{erreur}</div>}

        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Mot de passe</label>
            <input
              type="password"
              className="form-control"
              value={motDePasse}
              onChange={(e) => setMotDePasse(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="btn btn-primary w-100" disabled={loading}>
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                Connexion...
              </>
            ) : (
              "Se connecter"
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
